import React from 'react';
import { t } from 'i18next';
import styles from './PlanUsageUi.module.css';
import { FaCheck, FaTimes, FaSpinner, FaPause } from 'react-icons/fa';

const PlanUsageUi = ({ 
    planName, 
    instantJobActivation, 
    monthlyJobs, 
    totalMonthlyJobs, 
    jobseekerDatabaseAccess, 
    viewApplicantsProfile, 
    contactReveals, 
    totalContactReveals, 
    viewDownloadResume,
    isJobsLoading,
    isContactRevealsLoading,
    isPaused
}) => {
    
    const usageData = [
        {
            name: t('planUsage.instantJobActivation', 'Instant Job Activation'),
            value: instantJobActivation ? <FaCheck className={styles.checkIcon} /> : <FaTimes className={styles.crossIcon} />
        },
        {
            name: t('planUsage.monthlyJobs', 'Monthly Jobs'),
            value: isJobsLoading ? 
                <FaSpinner className={`${styles.spinnerIcon} ${styles.spin}`} /> : 
                (totalMonthlyJobs === 999999 || !totalMonthlyJobs ? 
                    isPaused ? <>
                    
{                    monthlyJobs >= totalMonthlyJobs ? 
                        <span className={styles.limitReached}>{t('planUsage.reached', 'Reached')}</span> :
                        `${monthlyJobs || 0}/${totalMonthlyJobs}`}

                    </> : `${t('planUsage.unlimited', 'Unlimited')}` : 
                    monthlyJobs >= totalMonthlyJobs ? 
                        <span className={styles.limitReached}>{t('planUsage.reached', 'Reached')}</span> :
                        `${monthlyJobs || 0}/${totalMonthlyJobs}`)
        },
        {
            name: t('planUsage.jobseekerDatabaseAccess', 'Jobseeker Database Access'),
            value: jobseekerDatabaseAccess ? <FaCheck className={styles.checkIcon} /> : <FaTimes className={styles.crossIcon} />
        },
        {
            name: t('planUsage.viewApplicantsProfile', 'View Applicants Profile'),
            value: viewApplicantsProfile ? <FaCheck className={styles.checkIcon} /> : <FaTimes className={styles.crossIcon} />
        },
        {
            name: t('planUsage.contactReveals', 'Contact Reveals'),
            value: isContactRevealsLoading ? 
                <FaSpinner className={`${styles.spinnerIcon} ${styles.spin}`} /> : 
                contactReveals >= totalContactReveals  ? 
                    <span className={styles.limitReached}>{t('planUsage.reached', 'Reached')}</span> :
                    `${contactReveals || 0}/${totalContactReveals || 0}`
        },
        {
            name: t('planUsage.viewDownloadResume', 'View/Download Resume'),
            value: viewDownloadResume ? <FaCheck className={styles.checkIcon} /> : <FaTimes className={styles.crossIcon} />
        }
    ];

    return (
        <div className={styles.planUsageContainer}>
            <div className={styles.currentPlanHeader}>
                <p className={styles.planHeading}>{t('planUsage.title', 'Plan Usage')}</p>
            </div>
            <div className={styles.selectedPlanContainer}>
                <div className={styles.planHeader}>
                    <div className={styles.renewal}>{planName || t('billing.planName')}</div>
                </div>
                <div className={`${styles.activeContainer} ${isPaused ? styles.pausedLink : styles.activeLink}`}>
                    <span>{isPaused ? t('billing.pausedStatus', 'Paused') : t('billing.activeStatus')}</span>
                </div>
            </div>
            <div className={styles.usageDataList}>
                {usageData.map((item, index) => (
                    <div key={index} className={styles.data}>
                        <p className={styles.name}>{item.name}</p>
                        <div className={styles.valueContainer}>
                            <div className={styles.value}>{item.value}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PlanUsageUi; 